import { render, staticRenderFns } from "./AgenciaTarifas.vue?vue&type=template&id=cb2bac12"
import script from "./AgenciaTarifas.vue?vue&type=script&lang=js"
export * from "./AgenciaTarifas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports